export const clockTabs = [
  { value: 1, ko: "오늘", en: "Today", es: "Hoy" },
  { value: 7, ko: "7일", en: "7D", es: "7D" },
  { value: 30, ko: "30일", en: "30D", es: "30D" }
]

export const clockBundle = {
  title: {
    ko: "시간대별 {resource} 패턴",
    en: "{resource} Pattern by Time of Day",
    es: "Patron de {resource} por franja horaria"
  },
  period: {
    today: {
      ko: "오늘 시간대별 기준",
      en: "Based on today's hourly data",
      es: "Basado en los datos horarios de hoy"
    },
    recent: {
      ko: "최근 {period}일 기준",
      en: "Based on the last {period} days",
      es: "Basado en los ultimos {period} dias"
    }
  },
  center: {
    mainPeak: { ko: "MAIN PEAK", en: "MAIN PEAK", es: "PICO PRINCIPAL" },
    todayPeak: { ko: "오늘 최대 소비", en: "Today's Peak Usage", es: "Pico de uso de hoy" },
    basePeak: { ko: "기준 피크 타임", en: "Peak Hour", es: "Hora pico" },
    todayUsage: { ko: "오늘 사용량", en: "Today's Usage", es: "Uso de hoy" },
    averageUsage: { ko: "시간대별 평균", en: "Hourly Average", es: "Promedio horario" },
    hour: { ko: "시", en: "H", es: "h" }
  }
}
